<template>
  <BModal
    data-testid="confirm-modal"
    size="sm"
    header-class="confirm-modal__header"
    body-class="confirm-modal__body"
    footer-class="confirm-modal__footer"
    :lazy="true"
    :visible="visible"
    :no-close-on-esc="okLoading && okLoadingPreventClose"
    :no-close-on-backdrop="okLoading && okLoadingPreventClose"
    @hide="hide"
  >
    <template #modal-header>
      <div>
        <h5
          data-testid="confirm-modal-title"
          class="modal-title confirm-modal__title"
        >
          <slot name="title" />
        </h5>
      </div>
      <button
        type="button"
        aria-label="Close"
        class="close"
        :disabled="okLoading && okLoadingPreventClose"
        @click="hide"
        @keydown="hide"
      >
        ×
      </button>
    </template>
    <slot name="content" />
    <template #modal-footer>
      <div class="confirm-modal__status text-small">
        <slot name="status" />
      </div>
      <div class="confirm-modal__actions">
        <b-button
          data-testid="confirm-modal-cancel-btn"
          :variant="cancelVariant"
          :disabled="okLoadingPreventClose && okLoading"
          @click="hide"
          v-text="cancelTitle"
        />
        <elActionBtn
          data-testid="confirm-modal-ok-btn"
          type="button"
          class="btn btn-danger ml-2"
          :loading="okLoading"
          @click="okClick"
        >
          {{ okTitle }}
        </elActionBtn>
      </div>
    </template>
  </BModal>
</template>

<script>
import { translate as t } from 'client/i18n/i18n'
import { BButton, BModal } from '@ui/components'
import elActionBtn from './elActionBtn.vue'

export default {
  components: {
    BButton,
    BModal,
    elActionBtn
  },
  props: {
    okTitle: {
      type: String,
      default: t('common.yesDelete')
    },
    cancelTitle: {
      type: String,
      default: t('common.cancel')
    },
    cancelVariant: {
      type: String,
      default: 'outline-secondary'
    },
    visible: Boolean,
    okLoading: Boolean,
    okLoadingPreventClose: Boolean
  },
  emits: ['hide', 'okClick'],
  methods: {
    hide(e) {
      this.$emit('hide')
    },
    okClick() {
      this.$emit('okClick')
    }
  }
}
</script>

<style lang="scss">
.modal {
  .confirm-modal {
    &__header {
      padding-bottom: 0.75rem;
      word-break: normal;
    }

    &__title {
      padding-top: 0.5rem;
      line-height: 1.45;
    }

    &__body {
      padding-top: 0;
      padding-bottom: 1.5rem;
    }

    &__footer {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    &__status {
      align-self: center;
      margin-right: 1rem;
      line-height: 1.3;
    }

    &__actions {
      flex-shrink: 0;
      margin-left: auto;
    }
  }
}
</style>
